export interface FilterAccess {
  accessAppDisconnected: boolean;
  configAppDisconnected: boolean;
  noGroup: boolean;
  hasCard: boolean;
  noCard: boolean;
}

export const FilterUserExpires = {
  Expired: 'expired',
  OneDay: '1day',
  OneWeek: '1week'
} as const;

export type FilterUserExpiresValue = (typeof FilterUserExpires)[keyof typeof FilterUserExpires];

export type FilterUserExpiresState = FilterUserExpiresValue | null;

export interface FilterRole {
  keyManager: boolean;
  administrator: boolean;
  installer: boolean;
}

export interface FilterOrigin {
  entraId: boolean;
  atlas: boolean;
  keySharing: boolean;
}

export interface UsersFilter {
  filterAccess: FilterAccess;
  filterUserExpires: FilterUserExpiresState;
  filterRole: FilterRole;
  filterOrigin: FilterOrigin;
}

export interface UsersFilterSetters {
  setFilterAccess: (value: FilterAccess | ((current: FilterAccess) => FilterAccess)) => void;
  setFilterUserExpires: (value: FilterUserExpiresState) => void;
  setFilterRole: (value: FilterRole | ((current: FilterRole) => FilterRole)) => void;
  setFilterOrigin: (value: FilterOrigin | ((current: FilterOrigin) => FilterOrigin)) => void;
}

export interface UsersFilterState {
  filter: UsersFilter;
  setters: UsersFilterSetters;
  clearAllFilters: () => void;
  isAnyFilterEnabled: boolean;
}
